// extracted by mini-css-extract-plugin
export default {"actions":"UiModalConfirm_actions_By62d","header":"UiModalConfirm_header_GdZfC"};